// import itemObj from '../itemObj'
// import backCountUtil from '../../../static/js/backCountUtil';
import objectUtil from '../../../static/js/objectUtil'

//继承表单的值
function inheritFormData(formData, fields, goodsDetail) {
  if (!fields || fields.length <= 0) return
  fields.forEach((field) => {
    let formVal = objectUtil.getValueByPath(formData, 'order.' + field)
    //当有值时进行赋值，0也是有值得一种
    if (formVal || formVal === 0) goodsDetail[field] = formVal
  })
}
// 判断是否有重复数据 返回true false， keyPathId 以什么Id 判断重复数据
function isRepeat(formData, addToWhere, newValue, keyPathId) {
  const items = formData[addToWhere]
  const getValue = objectUtil.getValueByPath
  return items.some((im) => getValue(im, keyPathId) === getValue(newValue, keyPathId))
}

//价格反算
function backCountPrice(formData, goodsDetail, vue) {
  let isOrderDiscountsTotalFn = false //是否需要计算折扣金额总计

  let tempPrice = [
    'PRODUCT_SHOPPING_10',
    'PRODUCT_SHOPPING_20',
    'PRODUCT_SHOPPING_30',
    'PRODUCT_SHOPPING_40',
  ]
  let code = objectUtil.getValueByPath(formData, 'order.priceRange.code')

  if (vue.useBackCountAddItems && vue.store) {
    //从往来单位取价
    if (tempPrice.indexOf(code) == -1) {
      //取上一次的价格且报价为0或不存在
      if (['PRICE_LAST_PREPARE', 'PRICE_LAST_SYSTEM'].includes(code) && !goodsDetail.pricing) {
        //价格反算
        vue.store.dispatch(vue.useBackCountAddItems, 'price', goodsDetail)
      } else {
        //刷新价格反算
        vue.store.dispatch(vue.useBackCountAddItems, 'refreshPrice', goodsDetail, formData)
        isOrderDiscountsTotalFn = true
      }
    } else {
      //价格反算
      vue.store.dispatch(vue.useBackCountAddItems, 'pricing', goodsDetail)
    }
  } else {
    console.error('调用计算失败-----useBackCountAddItems不存在或者vue.store不存在')
  }

  return isOrderDiscountsTotalFn
}

// 日期格式自定义
function formatDate(date) {
  // 满足 年 / - 三种模式的 日期格式
  var REG = /(2[0-9]{3})[年 | \/ | -]([0-9]{1,2})[月 | \/ | -]([0-9]{1,2})/g
  var reg = new RegExp(REG)
  reg.exec(date)
  var { $1, $2, $3 } = RegExp
  $2 = Number($2) < 10 ? '0' + Number($2) : $2
  $3 = Number($3) < 10 ? '0' + Number($3) : $3
  if ($1 && $2 && $3) return `${$1}-${$2}-${$3}`
  return null
}

//替换或者插入时反算六个折扣
function backCountRate(m, parm, itemGood, formData, vue) {
  let isOrderDiscountsTotalFn = false //是否需要计算折扣金额总计
  for (let i = 0; i < parm.type.length; i++) {
    let key = parm.type[i]
    let val = parm.data[key][m]
    let newVal = Number(val) // 此处兼容 val 是字符串时，直接取字符串...
    if (isNaN(newVal) || key.indexOf('batchNumber') !== -1 || key.indexOf('serialNumber') !== -1)
      newVal = val
    if (key === 'goodsKeeping.periodEnd' || key === 'goodsKeeping.periodBegin')
      newVal = formatDate(newVal) // 特殊处理 导入的 有效期至  日期格式...
    //赋值操作
    objectUtil.setValueByPath(itemGood, key, newVal)
    //进行反算
    if (vue.store && vue.useBackCountAddItems) {
      //普通的字段反算
      if (vue.store.dispatch('ifBackCountUtil', vue.useBackCountAddItems, key)) {
        vue.store.dispatch(
          vue.useBackCountAddItems,
          key === 'amount' ? 'amountBack' : key,
          itemGood,
          formData
        )
        if (key == 'amount' || key == 'amountDisplay') isOrderDiscountsTotalFn = true
      }
      //判断是否是六个折扣字段的反算
      else if (key.indexOf('discountRate') != -1) {
        let tempArr = key.split('.')
        if (tempArr.length == 3) {
          let tempKey = tempArr[1]
          vue.store.dispatch(vue.useBackCountAddItems, 'discountRate', itemGood, formData, tempKey)
          isOrderDiscountsTotalFn = true
        }
      } else if (key.indexOf('discountTotal') != -1) {
        let tempArr = key.split('.')
        if (tempArr.length == 3) {
          let tempKey = tempArr[1]
          vue.store.dispatch(vue.useBackCountAddItems, 'discountTotal', itemGood, formData, tempKey)
          isOrderDiscountsTotalFn = true
        }
      } else if (key.indexOf('discount') != -1) {
        let tempArr = key.split('.')
        if (tempArr.length == 3) {
          let tempKey = tempArr[1]
          vue.store.dispatch(vue.useBackCountAddItems, 'discount', itemGood, formData, tempKey)
          isOrderDiscountsTotalFn = true
        }
      }
    } else {
      console.error('调用计算失败-----useBackCountAddItems不存在或者vue.store不存在')
    }
  }

  //模板添加并且带出数量时需要反算价格
  if (parm.templateAmount) {
    if (itemGood.amountDisplay) {
      vue.store.dispatch(vue.useBackCountAddItems, 'amountDisplay', itemGood, formData)
    } else {
      vue.store.dispatch(vue.useBackCountAddItems, 'amount', itemGood, formData)
    }
    isOrderDiscountsTotalFn = true
  }

  return isOrderDiscountsTotalFn
}

//需求8681：是否开票、开票类型根据表格顶部取值，且当【是否开票=否】时【开票类型=无票】
function changeFormData(formData, fields, goodsDetail) {
  if (!fields || fields.length <= 0) return
  fields.forEach((field) => {
    let formVal = objectUtil.getValueByPath(formData, `_${field}`)
    objectUtil.setValueByPath(goodsDetail, field, formVal)
    if (field === 'finance' && formVal === false) {
      objectUtil.setValueByPath(goodsDetail, 'attrs.valueText.invoiceType', '无票')
    }
  })
}

//SKU闪加
function _flashAddMedical(newValue, oldValue, formData, addToWhere, vue) {
  //没有使用，进行注释
  // let goodsDetailIndicate =
  //   objectUtil.getValueByPath(vue, '$store.state.user.system.code') == 'LINK'
  //     ? 'goodsInfo'
  //     : 'goodsDetail'
  // console.log("watchInputHandle",newValue,oldValue,formData);
  if (!newValue) return
  // 修改药械闪加组件，返回的数据改完对象，当newValue.type为medical时，是高级查询和普通添加的分支，返回的数据对象里面得data属性为商品列表
  // 当newValue.type为insertion时是Excel复制添加和根据模板添加，向某行插入或者替换数据
  // 否则则是修改商品列表中的某些字段
  let isOrderDiscountsTotalFn = false,
    medicalArray,
    hasRepeat = false //判断是否需要计算折扣金额总计（如果存在从客户价格管理中取值的就需要计算）
  //直接添加和高级查询添加分支
  if (newValue.type == 'medical') {
    medicalArray = newValue.data
    // 缺省补全 addToWhere表示表格的字段,默认是items
    !formData[addToWhere] && (formData[addToWhere] = [])
    //处理条目，上游会把直接添加时和高级查询时，条目处理成数组，因为数据结构一致，
    medicalArray.forEach((goodsDetail, index) => {
      //口腔这里数据要设置为1 所以单独加一个参数amountEqualOne
      if (vue.amountEqualOne) {
        goodsDetail.amount = 1
      }
      // 判断是否是重复数据
      if (vue.keyPathId && isRepeat(formData, addToWhere, goodsDetail, vue.keyPathId)) {
        hasRepeat = true
        vue.$Message.warning(
          `您添加的${medicalArray.length > 1 ? `第${index + 1}条` : ''}数据重复，将不会添加到表格`
        )
        return
      }
      //需求8681：是否开票、开票类型根据表格顶部取值，且当【是否开票=否】时【开票类型=无票】
      let changeFields = ['attrs.valueText.invoiceType', 'finance']
      changeFormData(formData, changeFields, goodsDetail)

      //继承表单的值
      let fields = ['discount', 'arrival', 'arriving', 'rate']
      inheritFormData(formData, fields, goodsDetail)
      // 新版本药械闪加提供的数据是orderItem结构体。目前先兼容老数据，后续全部替换掉。
      // if (goodsDetail.hasOwnProperty(goodsDetailIndicate)) {
      //反算价格
      isOrderDiscountsTotalFn = backCountPrice(formData, goodsDetail, vue)
      //添加至表格中
      const pushData = objectUtil.clone(goodsDetail)
      pushData._ID = objectUtil.createID()
      formData[addToWhere].push(pushData)
      //   不再兼容老数据，因为工具组件的结构体不包含goodsDetail 或者goodsInfo,参考需求3777
      // } else {
      //     // 目前先兼容老数据，后续全部替换掉后，屏蔽该代码。
      //     let orderItem = {
      //         'amount': goodsDetail._inputNumber === undefined ? null : goodsDetail._inputNumber,
      //         'pricing': goodsDetail.pricing,
      //         'rate': goodsDetail.rate,
      //         'unit': goodsDetail.unit
      //     };
      //     orderItem[goodsDetailIndicate]=goodsDetail
      //     let tempObj = Object.assign(itemObj.initItem(), orderItem);
      //     //反算价格
      //     isOrderDiscountsTotalFn = backCountPrice(formData,tempObj,vue);
      //     //添加至表格中
      //     tempObj._ID = objectUtil.createID();
      //     formData[addToWhere].push(tempObj);
      // }
    })
  }
  // 通过excel复制，模板添加添加商品
  else if (newValue.type == 'insertion') {
    medicalArray = newValue.data.data || [] //要添加的数据
    let errorArray = newValue.data.errors // 错误的数据
    /**
     * Excel的参数控制
     * handleCode：是否进过后台转化结构体，true，没有经过后台转化，场景一般是用于批量替换表格中的某些值，比如数量，价格等
     * replace：替换还是插入
     * index：插入到第几行，计算提示的位置及插入时保证顺序
     * type: 数组，字段组成的集合；["code","price","amountDisplay"]
     * data: 对象，按照字段进行分类，{code:[1,2,3],price:[1,2,3],amountDisplay:[1,2,3]}
     *
     * **/
    let parm = newValue.prams // 一些参数
    if (!formData[addToWhere]) formData[addToWhere] = []
    let rowIndex = parm.index //插入到第几行

    // 获取处理成功和失败的条数
    let errorsInfo = vue.errorsInfo(
      medicalArray,
      errorArray,
      parm,
      formData,
      '添加失败，找不到商品，请核查后重新添加'
    )
    let successCount = errorsInfo.successCount //成功的条目
    let errorCount = errorsInfo.errorCount //失败的条目
    let errorList = errorsInfo.errorList //失败时的报错提示
    //更新至表单中
    vue.$refs.crudEdit.updateErrors(errorList)

    //开始处理数据条目
    for (let m = 0; m < medicalArray.length; m++) {
      let goodsDetail = medicalArray[m]
      //口腔这里数据要设置为1 所以单独加一个参数amountEqualOne
      if (vue.amountEqualOne) {
        goodsDetail.amount = 1
      }

      // 判断是否是重复数据
      if (vue.keyPathId && isRepeat(formData, addToWhere, goodsDetail, vue.keyPathId)) {
        hasRepeat = true
        vue.$Message.warning(
          `您添加的${medicalArray.length > 1 ? `第${m + 1}条` : ''}数据重复，将不会添加到表格`
        )
        continue
      }
      //需求8681：是否开票、开票类型根据表格顶部取值，且当【是否开票=否】时【开票类型=无票】
      let changeFields = ['attrs.valueText.invoiceType', 'finance']
      changeFormData(formData, changeFields, goodsDetail)

      //继承表单的值
      let fields = ['discount', 'arrival', 'arriving', 'rate']
      inheritFormData(formData, fields, goodsDetail)

      //记录原始的types
      const originalTypes = [...parm.type]

      //删除type和data中的code，code不能进行替换和赋值，这个是标志位
      let codeIndex = parm.type.indexOf('code')
      if (codeIndex != -1) {
        parm.type.splice(codeIndex, 1)
        delete parm.data.code
      }
      let putStorageNumbersIndex = parm.type.indexOf('putStorageNumbers')
      if (putStorageNumbersIndex != -1) {
        parm.type.splice(putStorageNumbersIndex, 1)
        delete parm.data.putStorageNumbers
      }
      let saleReturnSupplierIndex = parm.type.indexOf('saleReturnSupplier')
      if (saleReturnSupplierIndex != -1) {
        parm.type.splice(saleReturnSupplierIndex, 1)
        delete parm.data.saleReturnSupplier
      }
      let saleReturnAgreementIndex = parm.type.indexOf('saleReturnAgreement')
      if (saleReturnAgreementIndex != -1) {
        parm.type.splice(saleReturnAgreementIndex, 1)
        delete parm.data.saleReturnAgreement
      }

      //商品安全库存中删除不需要的字段
      //定数包
      let shelvesIndex = parm.type.indexOf('numberPackage')
      if (shelvesIndex != -1) {
        parm.type.splice(shelvesIndex, 1)
        delete parm.data.numberPackage
      }
      //unitDisplay
      let unitDisplayIndex = parm.type.indexOf('unitDisplay')
      if (unitDisplayIndex != -1) {
        parm.type.splice(unitDisplayIndex, 1)
        delete parm.data.unitDisplay
      }

      /**
       * 后台转化后的结构体需要进行价格反算，这表示新增或者替换整个条目，(如果复制Excel中包含生产批号、序列号、入库批次则不进行反算)
       * #35663, 新增对序列号的判断，否则通过excel导入时只选择序列号和数量时价格等显示会出现异常（此操作不需要进行反算）
       */
      if (
        !parm.handleCode &&
        !(
          originalTypes.indexOf('batchNumber') > -1 ||
          originalTypes.indexOf('serialNumber') > -1 ||
          originalTypes.indexOf('putStorageNumbers') > -1
        )
      ) {
        //反算价格
        isOrderDiscountsTotalFn = backCountPrice(formData, goodsDetail, vue)
      }

      let itemGood = goodsDetail
      //替换条目中部分值的场景
      if (parm.replace && parm.handleCode && rowIndex < formData[addToWhere].length) {
        itemGood = formData[addToWhere][rowIndex]
      }

      //把Excel复制中的值赋给条目中，并进行反算
      isOrderDiscountsTotalFn = backCountRate(m, parm, itemGood, formData, vue)
      itemGood._ID = objectUtil.createID()
      if (parm.replace) {
        formData[addToWhere].splice(rowIndex, 1, itemGood)
      } else {
        formData[addToWhere].splice(rowIndex, 0, itemGood)
      }
      rowIndex += 1
    }
    if (parm.scanCode && errorArray) {
      vue.$pgMessage.confirm({
        title: '提示',
        content: errorArray[0].message,
        onOk: () => {
          return
        },
      })
    }
    if (!parm.scanCode) {
      vue.$pgMessage.modalUpdateResult({
        title: '识别商品信息结果',
        textUpdateResult: '商品添加完毕！本次成功添加商品',
        errorText: '其中',
        errorTextAfter: '条存在问题',
        resultData: {
          success: successCount,
          fail: errorCount,
        },
      })
    }
  }
  if (!hasRepeat) vue.$Message.success('已添加!')
  if (isOrderDiscountsTotalFn) {
    vue.store.dispatch(vue.useBackCountAddItems, 'orderDiscountsTotalFn', formData)
  }
}

//SPU闪加
function _flashAddMedicalForProduct(newValue, oldValue, formData, addToWhere, vue) {
  if (!newValue) return
  // 修改药械闪加组件，返回的数据改完对象，当type为medical时，返回的数据对象里面得data属性为产品列表
  // 当type为insertion时向某行插入或者替换数据
  // 否则则是修改产品列表中的某些字段
  let isOrderDiscountsTotalFn = false,
    medicalArray,
    hasRepeat = false //判断是否需要计算折扣金额总计（如果存在从客户价格管理中取值的就需要计算）
  if (newValue.type == 'medical') {
    medicalArray = newValue.data
    if (!formData[addToWhere]) formData[addToWhere] = []
    medicalArray.forEach((waresDetail, index) => {
      // 判断是否是重复数据
      if (vue.keyPathId && isRepeat(formData, addToWhere, waresDetail, vue.keyPathId)) {
        hasRepeat = true
        vue.$Message.warning(
          `您添加的${medicalArray.length > 1 ? `第${index + 1}条` : ''}数据重复，将不会添加到表格`
        )
        return
      }
      //继承表单的值
      let fields = ['discount', 'arrival', 'arriving', 'rate']
      inheritFormData(formData, fields, waresDetail)

      waresDetail._ID = objectUtil.createID()
      //反算价格
      isOrderDiscountsTotalFn = backCountPrice(formData, waresDetail, vue)
      formData[addToWhere].push(waresDetail)
    })
  } else if (newValue.type == 'insertion') {
    // 通过excel复制添加产品
    medicalArray = newValue.data.data || [] //要添加的数据
    let errorArray = newValue.data.errors // 错误的数据
    /**
     * Excel的参数控制
     * handleCode：是否进过后台转化结构体，true，没有经过后台转化，场景一般是用于批量替换表格中的某些值，比如数量，价格等
     * replace：替换还是插入
     * index：插入到第几行，计算提示的位置及插入时保证顺序
     * type: 数组，字段组成的集合；["code","price","amountDisplay"]
     * data: 对象，按照字段进行分类，{code:[1,2,3],price:[1,2,3],amountDisplay:[1,2,3]}
     *
     * **/
    let parm = newValue.prams
    if (!formData[addToWhere]) formData[addToWhere] = []
    let rowIndex = parm.index

    // 获取处理成功和失败的条数
    let errorsInfo = vue.errorsInfo(
      medicalArray,
      errorArray,
      parm,
      formData,
      '添加失败，找不到产品，请核查后重新添加'
    )
    let successCount = errorsInfo.successCount
    let errorCount = errorsInfo.errorCount
    let errorList = errorsInfo.errorList
    vue.$refs.crudEdit.updateErrors(errorList)

    //开始处理数据条目
    for (let m = 0; m < medicalArray.length; m++) {
      let waresDetail = medicalArray[m]
      // 判断是否是重复数据
      if (vue.keyPathId && isRepeat(formData, addToWhere, waresDetail, vue.keyPathId)) {
        hasRepeat = true
        vue.$Message.warning(
          `您添加的${medicalArray.length > 1 ? `第${m + 1}条` : ''}数据重复，将不会添加到表格`
        )
        continue
      }
      //继承表单的值
      let fields = ['discount', 'arrival', 'arriving', 'rate']
      inheritFormData(formData, fields, waresDetail)

      //删除waresCodes，其他的字段参与反算，如果是没有定义的字段，在反算的方法里面过滤，这里强化保证waresCodes不会出错
      let codeIndex = parm.type.indexOf('waresCodes')
      if (codeIndex != -1) {
        parm.type.splice(codeIndex, 1)
        delete parm.data.waresCodes
      }
      //如果不走后台的结构体，反算报价一次，保证数据正确
      if (!parm.handleCode) {
        //反算价格
        isOrderDiscountsTotalFn = backCountPrice(formData, waresDetail, vue)
      }

      let itemGood = waresDetail
      if (parm.replace && parm.handleCode && rowIndex < formData[addToWhere].length) {
        // 替换的情况
        itemGood = formData[addToWhere][rowIndex]
      }

      //把Excel复制中的值赋给条目中，并进行反算
      isOrderDiscountsTotalFn = backCountRate(m, parm, itemGood, formData, vue)

      itemGood._ID = objectUtil.createID()
      if (parm.replace) {
        // backCountUtil.pricingDisplay(itemGood);
        formData[addToWhere].splice(rowIndex, 1, itemGood)
        //新增属性不会显示，整体重新赋值
        formData[addToWhere] = JSON.parse(JSON.stringify(formData[addToWhere]))
      } else {
        // backCountUtil.pricingDisplay(goodsDetail);
        formData[addToWhere].splice(rowIndex, 0, waresDetail)
      }
      rowIndex += 1
    }

    vue.$pgMessage.modalUpdateResult({
      title: '识别产品信息结果',
      textUpdateResult: '产品添加完毕！本次成功添加产品',
      errorText: '其中',
      errorTextAfter: '条存在问题',
      resultData: {
        success: successCount,
        fail: errorCount,
      },
    })
  }
  if (!hasRepeat) vue.$Message.success('已添加!')
  if (isOrderDiscountsTotalFn) {
    vue.store.dispatch(vue.useBackCountAddItems, 'orderDiscountsTotalFn', formData)
  }
}

export default {
  //商品药械闪加
  _flashAddMedical,
  //产品药械闪加
  _flashAddMedicalForProduct,
  //判断是否重复
  isRepeat,
}
